function get_access_token() {
  let access_token = localStorage.getItem("token");
  if (access_token) {
    return access_token;
  } else {
    // console.log("access token not found");
    // window.location.href = "/";
    return;
  }
}

function setUserInfo(user) {
  localStorage.setItem("isAuthenticated", true);
  localStorage.setItem("machine_id", user["machine_id"]);
}

/* 
Device detail
session detail
browser detail 
and UUID
*/

const getDeviceDetails = (mid, session, uid) => {
  return {
    machineId: mid,
    sessionId: session,
    uuid: uid,
    // ip: fetchIpAddress(),
    userAgent: navigator.userAgent,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
    language: navigator.language,
    platform: navigator.platform,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    referrer: document.referrer,
    deviceType: getDeviceType(),
    browserDetail: getBrowserType(),
  };
};

const getDeviceType = () => {
  const userAgent = navigator.userAgent;
  if (/iPhone|iPad|iPod|Android/i.test(userAgent)) {
    return "Mobile";
  }
  if (/iPad|Android|Touch/.test(userAgent) && !/mobile/i.test(userAgent)) {
    return "Tablet";
  }
  return "Desktop";
};

const getBrowserType = () => {
  const userAgent = navigator.userAgent;
  let browserType = "";
  let browserVersion = "";

  if (userAgent.indexOf("Firefox") > -1) {
    browserType = "Firefox";
    browserVersion = userAgent.substring(userAgent.indexOf("Firefox") + 8);
  } else if (userAgent.indexOf("Chrome") > -1) {
    browserType = "Chrome";
    browserVersion = userAgent.substring(userAgent.indexOf("Chrome") + 7);
  } else if (userAgent.indexOf("Safari") > -1) {
    browserType = "Safari";
    browserVersion = userAgent.substring(userAgent.indexOf("Version") + 8);
  } else if (
    userAgent.indexOf("MSIE") > -1 ||
    userAgent.indexOf("Trident/") > -1
  ) {
    browserType = "Internet Explorer";
    browserVersion = userAgent.substring(userAgent.indexOf("MSIE") + 5);
  } else {
    browserType = "Unknown";
    browserVersion = "Unknown";
  }
  // console.log('browser', browserType + browserVersion);
  return browserType + "-" + browserVersion;
};

// disable browsers
export const disableContextMenu = () => {
  const handleContextMenu = (event) => {
    event.preventDefault();
  };

  document.addEventListener("contextmenu", handleContextMenu);

  return () => {
    document.removeEventListener("contextmenu", handleContextMenu);
  };
};

export const disableKeyShortcuts = () => {
  const handleKeyDown = (event) => {
    if (
      (event.ctrlKey && event.shiftKey && event.key === "I") || // Ctrl+Shift+I
      (event.ctrlKey && event.shiftKey && event.key === "J") || // Ctrl+Shift+J
      (event.ctrlKey && event.key === "U") || // Ctrl+U
      event.key === "F12" // F12
    ) {
      event.preventDefault();
    }
  };

  document.addEventListener("keydown", handleKeyDown);

  return () => {
    document.removeEventListener("keydown", handleKeyDown);
  };
};

const version = "v2.0.0";

export {
  get_access_token,
  setUserInfo,
  getBrowserType,
  getDeviceType,
  getDeviceDetails,
  version,
};
